export class IndividualPreferenceTypeReferenceModel {
    public individualPreferenceTypeCode: string;
    public individualPreferenceTypeName: string;
    public sortSequence: number;
}